var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.291 1.9165H6.70768C4.06268 1.9165 1.91602 4.05359 1.91602 6.689V12.4198V13.3782C1.91602 16.0136 4.06268 18.1507 6.70768 18.1507H8.14518C8.40393 18.1507 8.74893 18.3232 8.91185 18.534L10.3493 20.4411C10.9818 21.2844 12.0168 21.2844 12.6493 20.4411L14.0868 18.534C14.2689 18.2944 14.5564 18.1507 14.8535 18.1507H16.291C18.936 18.1507 21.0827 16.0136 21.0827 13.3782V6.689C21.0827 4.05359 18.936 1.9165 16.291 1.9165ZM7.66602 11.4998C7.12935 11.4998 6.70768 11.0686 6.70768 10.5415C6.70768 10.0144 7.13893 9.58316 7.66602 9.58316C8.1931 9.58316 8.62435 10.0144 8.62435 10.5415C8.62435 11.0686 8.20268 11.4998 7.66602 11.4998ZM11.4993 11.4998C10.9627 11.4998 10.541 11.0686 10.541 10.5415C10.541 10.0144 10.9723 9.58316 11.4993 9.58316C12.0264 9.58316 12.4577 10.0144 12.4577 10.5415C12.4577 11.0686 12.036 11.4998 11.4993 11.4998ZM15.3327 11.4998C14.796 11.4998 14.3743 11.0686 14.3743 10.5415C14.3743 10.0144 14.8056 9.58316 15.3327 9.58316C15.8598 9.58316 16.291 10.0144 16.291 10.5415C16.291 11.0686 15.8693 11.4998 15.3327 11.4998Z",
    fill: "#065F46"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.bf10f2b63aa7fba5fbb99f390906e99d.svg";
export { ForwardRef as ReactComponent };